<template>
  <div
    :class="`main-menu menu-fixed menu-accordion ${!isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) ? 'expanded' : ''} menu-light`"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link
              class="navbar-brand"
              to="/"
            >
              <span class="brand-logo">
                <b-img
                  :class="`img-fluid ${imgLogoVertical ? 'vertical-logo' : ''}`"
                  :src="imgLogo"
                  alt="logo"
                />
              </span>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li
            class="nav-item nav-toggle" 
          >
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                style="color: white !important"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
      <vertical-nav-menu-items
        :items="
          menuItems && Array.isArray(menuItems[0])
            ? menuItems[0]
            : menuItems
              ? menuItems
              : []"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { BImg, BLink } from 'bootstrap-vue'
import { computed, provide, reactive, ref, toRefs } from '@vue/composition-api'
import { mapGetters } from 'vuex'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import { avatarText } from '@core/utils/filter'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      imgLogoVertical: false,
      imgLogo: this.appLogoImageWhite,

    }
  },
  computed: {
    ...mapGetters({ menuItems: 'verticalMenu/menuItems' }),
  },
  watch: {
    isMouseHovered(hooverValue) {
      if (this.isVerticalMenuCollapsed) {
        if (hooverValue) {
          this.imgLogo = this.appLogoImageWhite
          this.imgLogoVertical = false
          return
        } this.imgLogo = this.appLogoImageWhiteVertical
        this.imgLogoVertical = true
      }
    },
  },
  beforeMount() {
    this.$store.dispatch('verticalMenu/getMenuItems')
  },
  setup(props) {
    const currentUserStore = createNamespacedHelpers('currentUser')
    const state = reactive({
      user: currentUserStore.useGetters(['user']).user,
    })

    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    // App Name
    const { appName, appLogoImageWhite, appLogoImageWhiteVertical } = $themeConfig.app

    return {
      ...toRefs(state),
      appLogoImageWhite,
      appLogoImageWhiteVertical,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,

      // MISC
      avatarText,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
